import React, { useRef, useEffect, useState } from 'react';
import './BakeryHero.css';

const PLACEHOLDER_IMG =
  'https://afag.imgix.net/pablitos-tacos-burbank/franchise.heic?w=2000&auto=format'; // Replace with your placeholder image URL

const BakeryHero = () => {
  const videoRef = useRef(null);
  const [videoError, setVideoError] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  // Lazy-load autoplay with IntersectionObserver
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (
          entry.isIntersecting &&
          videoRef.current &&
          videoRef.current.paused &&
          !videoError
        ) {
          videoRef.current.play().catch(() => {});
        }
      },
      { threshold: 0.5 }
    );
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, [videoError]);

  const togglePlayback = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  };

  return (
    <div className="hero-container">
      {!videoLoaded || videoError ? (
        <img
          src={PLACEHOLDER_IMG}
          alt="Pablito's Tacos"
          className="hero-video hero-placeholder"
        />
      ) : null}
      <video
        ref={videoRef}
        aria-label="Pablito's Tacos video"
        muted
        loop
        playsInline
        preload="none"
        className="hero-video"
        onClick={togglePlayback}
        style={{
          display: !videoLoaded || videoError ? 'none' : 'block',
        }}
        onLoadedData={() => setVideoLoaded(true)}
        onError={() => setVideoError(true)}
      >
        <source
          src="https://res.cloudinary.com/dwmjfe3bd/video/upload/v1755628985/pablitos-hero-2_isuiu5.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      {/* <div className="hero-text">
        <h1>Pablito's Tacos</h1>
        <p>Street Tacos · Smash Burgers · Pizza · Rotiesserie</p>
      </div> */}

      {/* <button
        className="hero-toggle-button"
        onClick={togglePlayback}
        aria-label="Toggle video"
      >
        ❚❚
      </button> */}
    </div>
  );
};

export default BakeryHero;